<template>
  <div class="animated fadeIn">
    <Tabs type="card" @on-click="onTabClick">
      <TabPane label="自定义分组统计">
        <custom-group-report ref="customGroupReport"></custom-group-report>
      </TabPane>
      <TabPane label="月度分组统计">
        <month-group-report ref="monthGroupReport"></month-group-report>
      </TabPane>
      <TabPane label="季度分组统计">
        <quarter-group-report ref="quarterGroupReport"></quarter-group-report>
      </TabPane>
      <TabPane label="年度分组统计">
        <year-group-report ref="yearGroupReport"></year-group-report>
      </TabPane>
    </Tabs>
  </div>
</template>

<script>

import CustomGroupReport from '@/view/br/components/custom-group-report'
import MonthGroupReport from '@/view/br/components/month-group-report'
import QuarterGroupReport from '@/view/br/components/quarter-group-report'
import YearGroupReport from '@/view/br/components/year-group-report'

export default {
  name: 'groupalbrreport',
  components: {
    CustomGroupReport,
    MonthGroupReport,
    QuarterGroupReport,
    YearGroupReport
  },
  data () {
    return {

    }
  },
  methods: {
    onTabClick (name) {
      switch (name) {
        case 0:
          this.$refs.customGroupReport.onShow()
          break
        case 1:
          this.$refs.monthGroupReport.onShow()
          break
        case 2:
          this.$refs.quarterGroupReport.onShow()
          break
        case 3:
          this.$refs.yearGroupReport.onShow()
          break
      }
    }
  },
  mounted () {
    const token = this.$store.getters.token
  }
}
</script>

<style type="text/css" scoped>
</style>
